import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import SearchPaging from "./../factories/search-paging";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import TreeNodeViewModel from "./../factories/tree-node";
import TabPage from "./../factories/tab-page";
import "./../bindings/bao-searcher";
import "./../bindings/bao-tree";
import AppTabController from "../services/app-tab-controller";

function TicketTemplateViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    console.log(tabPage);
    self.Bao = Bao;
    self.Initialized = ko.observable(false);
    self.IsReadonly = ko.observable(false);
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.Name())) {
            isComplete = false;
        }
        if (self.TicketPriorityId() == null) {
            isComplete = false;
        }
        if (self.TicketTypeId() == null) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    self.BeforeDelete = function () {
        Bao.post("TicketTemplate/IsTicketTemplateInUse", JSON.stringify({
            id: self.OpenData()
        }), function (value) {
            if (value != "true") {
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgDeleteTicketTemplate"), "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result === true) {
                        self.Delete();
                    }
                });
            }
            else {
                new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgIsInUse"), "info");
            }
        });
    };
    self.Save = function () {
        tabPage.IsLoading(true);
        return Bao.post("TicketTemplate/SaveTicketTemplate", JSON.stringify({
            ticketTemplate: self.MinimizeEntity()
        }), function (value) {
            self.SaveTime(value.Result);
            self.PerformRefresh();
        });
    };
    self.Delete = function () {
        tabPage.IsLoading(true);
        return Bao.post("TicketTemplate/DeleteTicketTemplate", JSON.stringify({
            ticketTemplate: self.MinimizeEntity()
        }), function (value) {
            tabPage.IsLoading(false);
            AppTabController.RemoveTab(tabPage);
        });
    };
    tabPage.MenuEvents.push(BaoMenu.registerEvent(function (value) {
        if (tabPage.IsActiveTab() == true) {
            switch (value.ActionKey()) {
                case "TicketTemplateSave":
                    if (self.CompleteCheck() == true) {
                        self.Save();
                    }
                    break;
                case "TicketTemplateRefresh":
                    self.BeforeRefresh();
                    break;
                case "TicketTemplateDelete":
                    self.BeforeDelete();
                    break;
                case "TicketTemplateMoveForwardSearch":
                    self.MoveSearch(self.CurrentSearchIndex() + 1);
                    break;
                case "TicketTemplateMoveBackwardSearch":
                    self.MoveSearch(self.CurrentSearchIndex() - 1);
                    break;
            }
        }
    }));
    self.DeleteService = function () {
        self.TicketServiceStructureName(null);
        self.TicketServiceStructureId(null);
    };
    self.GoToAffectedPerson = function () {
        var newTab = new TabPage();
        newTab.Url("ConfigurationItem/Person");
        newTab.UrlData({
            id: self.AffectedPersonId()
        });
        newTab.ObjectId(self.AffectedPersonId());
        AppTabController.AddTab(newTab);
    };
    self.GoToReportingPerson = function () {
        var newTab = new TabPage();
        newTab.Url("ConfigurationItem/Person");
        newTab.UrlData({
            id: self.ReportingPersonId()
        });
        newTab.ObjectId(self.ReportingPersonId());
        AppTabController.AddTab(newTab);
    };
    self.GoToAffectedConfigurationItem = function () {
        var newTab = new TabPage();
        newTab.Url("ConfigurationItem");
        newTab.UrlData({
            id: self.AffectedConfigurationItemId()
        });
        newTab.ObjectId(self.AffectedConfigurationItemId());
        AppTabController.AddTab(newTab);
    };
    self.OpenTreeDialog = function (type) {
        tabPage.IsLoading(true);
        Bao.post("Ticket/GetTreeDialogDataSource", JSON.stringify({
            type: type
        }), function (value) {
            var dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
            var dialogViewModel : any = {};
            dialogViewModel.NodeToggled = function (node) {
                if (node.Loaded() == false) {
                    tabPage.IsLoading(true);
                    var parentId = node.Id();
                    Bao.post("Ticket/GetTreeDialogDataSourceByParent", JSON.stringify({
                        type: type,
                        parentId: parentId
                    }), function (value) {
                        for (var i = 0; i < value.nodes.length; i++) {
                            node.Nodes.push(new TreeNodeViewModel(value.nodes[i]));
                        }
                        node.Expanded(true);
                        node.Loaded(true);
                        dialog.SetPosition();
                        tabPage.IsLoading(false);
                    });
                }
                else {
                    dialog.SetPosition();
                }
            };
            var dataSource = [];
            for (var i = 0; i < value.nodes.length; i++) {
                dataSource.push(new TreeNodeViewModel(value.nodes[i]));
            }
            dialogViewModel.Nodes = ko.observableArray(dataSource);
            dialogViewModel.SelectedService = ko.observable();
            var selectedServiceSubscription = dialogViewModel.SelectedService.subscribe(function () {
                dialogViewModel.okClick();
            });
            dialogViewModel.SelectedCategory = ko.observable();
            var selectedCategorySubscription = dialogViewModel.SelectedCategory.subscribe(function () {
                dialogViewModel.okClick();
            });
            dialogViewModel.okClick = function () {
                tabPage.IsLoading(true);
                var selectedNode;
                switch (type) {
                    case "TicketService":
                        selectedNode = dialogViewModel.SelectedService();
                        if (selectedNode != null) {
                            if (selectedNode.IsAllowed()) {
                                return Bao.post("Ticket/GetTicketServiceStructure", JSON.stringify({
                                    selectedTicketServiceId: selectedNode.Id()
                                }), function (result) {
                                    self.InitializeDataBindingTicketServiceStructure(result.TicketServiceStructureId);
                                    self.TicketServiceStructureId(result.TicketServiceStructureId);
                                    self.OwnerPersonId(result.OwnerUserId);
                                    self.OwnerPersonName(result.OwnerUserName);
                                    self.OwnerServiceProviderId(result.OwnerRoleId);
                                    self.OwnerServiceProviderName(result.OwnerRoleName);
                                    self.DispatcherPersonId(result.DispatcherUserId);
                                    self.DispatcherPersonName(result.DispatcherUserName);
                                    self.DispatcherServiceProviderId(result.DispatcherRoleId);
                                    self.DispatcherServiceProviderName(result.DispatcherRoleName);
                                    dialog.Close();
                                    tabPage.IsLoading(false);
                                    selectedServiceSubscription.dispose();
                                    selectedServiceSubscription = null;
                                    dialogViewModel.SelectedService(null);
                                });
                            }
                        }
                        tabPage.IsLoading(false);
                        new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("TicketServiceInvalidSelection"), "info");
                        break;
                }
                return null;
            };
            dialog.Width(500);
            dialog.ViewModel(dialogViewModel);
            dialog.Template(value.Message);
            dialog.Buttons([{
                    Title: Bao.Session.GetMessage("msgOk"),
                    Enabled: ko.observable(true),
                    Click: dialogViewModel.okClick
                }]);
            dialog.Open();
            tabPage.IsLoading(false);
            dialog.SetPosition();
        });
    };
    self.InitializeDataBindingTicketServiceStructure = function (id) {
        Bao.post("Ticket/GetCompleteTicketServiceStructure", JSON.stringify({
            id: id
        }), function (value) {
            self.TicketServiceStructureName(value);
        });
    };
    self.OwnerServiceProviderChanged = function (selectedRow) {
        if (self.OwnerPersonId() != null) {
            Bao.post("Ticket/IsPersonInServiceProvider", JSON.stringify({
                personId: self.OwnerPersonId(),
                serviceProviderId: self.OwnerServiceProviderId()
            }), function (value) {
                if (value != true) {
                    self.OwnerPersonName(null);
                    self.OwnerPersonId(null);
                }
            });
        }
    };
    self.OwnerServiceProviderDeleted = function () {
        self.OwnerPersonDeleted();
    };
    self.OwnerPersonDeleted = function () {
        self.OwnerPersonId(null);
        self.OwnerPersonName(null);
    };
    self.DispatcherServiceProviderChanged = function (selectedRow) {
        if (self.DispatcherPersonId() != null) {
            Bao.post("Ticket/IsPersonInServiceProvider", JSON.stringify({
                personId: self.DispatcherPersonId(),
                serviceProviderId: self.DispatcherServiceProviderId()
            }), function (value) {
                if (value != true) {
                    self.DispatcherPersonName(null);
                    self.DispatcherPersonId(null);
                }
            });
        }
    };
    self.DispatcherServiceProviderDeleted = function () {
        self.DispatcherPersonDeleted();
    };
    self.DispatcherPersonDeleted = function () {
        self.DispatcherPersonId(null);
        self.DispatcherPersonName(null);
    };
    self.ServiceServiceProviderChanged = function (selectedRow) {
        if (self.ServicePersonId() != null) {
            Bao.post("Ticket/IsPersonInServiceProvider", JSON.stringify({
                personId: self.ServicePersonId(),
                serviceProviderId: self.ServiceServiceProviderId()
            }), function (value) {
                if (value != true) {
                    self.ServicePersonName(null);
                    self.ServicePersonId(null);
                }
            });
        }
    };
    self.ServiceServiceProviderDeleted = function () {
        self.ServicePersonDeleted();
    };
    self.ServicePersonDeleted = function () {
        self.ServicePersonId(null);
        self.ServicePersonName(null);
    };
    self.AfterGetTemplate = function (model) {
        ko.map.fromJS(model, self, self.TabPage.DirtyFlag);
        self.TabPage.SessionTabId = self.SessionTabId();
        if (self.IsNew() || self.TabPage.ObjectId() != self[self.PrimaryKey]()) {
            self.TabPage.ObjectId(self[self.PrimaryKey]());
        }
        else {
            self.TabPage.ObjectId.valueHasMutated();
        }
    };
    self.init = function () {
        self.TabPage.IsLoading(true);
        if (tabPage.Object != null && tabPage.Object.ticketModel != null) {
            return Bao.post("TicketTemplate/GetTicketTemplateByTicket", JSON.stringify({
                ticketModel: ko.map.toJS(tabPage.Object.ticketModel)
            }), function (model) {
                self.AfterGetTemplate(model);
            });
        }
        else {
            return Bao.post("TicketTemplate/GetTicketTemplate", JSON.stringify({
                id: self.TabPage.UrlData().id
            }), function (model) {
                self.AfterGetTemplate(model);
            });
        }
    };
}
Bao.inherit(TicketTemplateViewModel, SearchPaging);
TicketTemplateViewModel.prototype.PrimaryKey = "TicketTemplateId";
TicketTemplateViewModel.prototype.RefreshUrl = "TicketTemplate/GetTicketTemplate";
TicketTemplateViewModel.prototype.PermissionForward = "TicketTemplateMoveForwardSearch";
TicketTemplateViewModel.prototype.PermissionBackward = "TicketTemplateMoveBackwardSearch";
export default TicketTemplateViewModel;